import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';

import { throttle, isMobile } from "../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { getApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"

import ObjListPushsThematiqueFormation from './inc/ObjListPushsThematiqueFormation'
import ObjParcours from './inc/ObjParcours'

import '../assets/css/0010_sections/0420_section_content_formation.css'
import '../assets/css/0020_objects/0800_obj_navigation_header_formation.css'

class PageFormationsMarque extends Component {  //GIT FormationsMarque
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}
	componentDidMount() {
		getApiDatas(`/apiaox/Call/PageFormation?sBrandCode=${this.props.fields.data.scDatas?.Brand.codeAbbrege.value}`).then((apiDatas) => { 
            this.setState({ apiDatas:apiDatas }) 
            window.scrollTo(0,0)
        })
	}

    render() {
        const pageDatas = this.props.sitecoreContext.route?.fields;
        const { scDatas } = this.props.fields.data;
        const { apiDatas } = this.state;

        return (<>{ pageDatas &&scDatas && apiDatas && <>
			<section className="obj_section section_hero_formation">
				<div className="ctn_section">
					<div className="ctn_text">
                        <Text className="t_title" field={pageDatas["Page Title"]} tag="h1"></Text>
                        <Text className="t_desc" field={pageDatas["Page Text"]} tag="p"></Text>
					</div>
				</div>
			</section>

			<section className="obj_section section_content_formation">
				<div className="ctn_section">
					<div className="ctn_content">
                        {apiDatas.Parcours && <ObjParcours datasParcours={apiDatas.Parcours} scDatas={scDatas}/>}

						{scDatas.Brand?.ListThemeFolder[0]?.ListTheme && <ObjListPushsThematiqueFormation datasThemes={scDatas.Brand.ListThemeFolder[0].ListTheme}/>}
					</div>
				</div>
			</section>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageFormationsMarque));